import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { Box, Typography, Container } from "@mui/material"
import { CheckCircle } from "@mui/icons-material"
import logo from "../../assets/images/logo.jpeg"

export default function SuccessPage() {
    const navigate = useNavigate()

    // Optional: Automatically redirect after a certain time
    useEffect(() => {
        const timer = setTimeout(() => {
            navigate("/consultancy") 
        }, 7000)

        return () => clearTimeout(timer)
    }, [navigate])

    return (
        <Container maxWidth="md" sx={{ py: { xs: 3, sm: 4, md: 6 }, px: { xs: 2, sm: 3, md: 4 } }}>
            <Box
                elevation={0}
                sx={{
                    width: "100%",
                    maxWidth: "600px",
                    mx: "auto",
                    p: { xs: 3, sm: 4, md: 5 },
                    borderRadius: 2,
                    textAlign: "center",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        width: "100%",
                    }}
                >
                    <Box sx={{ mb: 4, width: "100%", maxWidth: 100, mx: "auto", display: "flex", justifyContent: "center" }}>
                        <img
                            src={logo || "/placeholder.svg"}
                            alt="E1X Academy Logo"
                            width={100}
                            height={50}
                            style={{ objectFit: "contain" }}
                        />
                    </Box>

                    <CheckCircle
                        sx={{
                            fontSize: 80,
                            color: "#D43D10",
                            mb: 3,
                        }}
                    />

                    <Typography
                        component="h1"
                        variant="h4"
                        fontWeight="bold"
                        sx={{ mb: 2, fontSize: { xs: "1.5rem", sm: "2rem", md: "2.125rem" } }}
                    >
                        Request Recieved
                    </Typography>

                    <Typography variant="body1" color="text.secondary" sx={{ mb: 2, maxWidth: "450px", mx: "auto" }}>
                        Thank you for trusting E1X to support your hiring needs.
                        Our team is reviewing your request and will begin matching you with the most suitable talent from our pool of industry-ready professionals.
                        You can expect to hear from us within 1–2 business days with next steps.
                    </Typography>

                    <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
                        We look forward to exploring potential opportunities together.
                    </Typography>
                </Box>
            </Box>
        </Container>
    )
}
